/**
 * Exports Module
 * 
 * This module re-exports all important functions and types from the various modules.
 * It allows users to import directly from the main module file.
 * 
 * Example:
 * import { reactiveStore, AsReactiveComponent } from 'as-components.v0.0.10.m.js';
 */

// Re-export from store.ts
export { reactiveStore } from './store/store.ts';

// Re-export from store-registry.ts
export { registerStore, getStore, getDefaultStore } from './store/store-registry.ts';

// Re-export from as-reactive-component.ts
export { AsReactiveComponent } from './components/base/as-reactive-component.ts';
import { devlog, redirTo } from './logic/utils.ts';


export const AsUtils = {
  devlog,
  redirTo
}

// Re-export types from as-components.d.ts
export type {
  IReactiveComponent,
  IReactiveStore,
  SubbedProps,
  UpdateHandler,
  EventBinding,
  EventBindingMap
} from './as-components.d.ts';

// Re-export from as-api.ts
export { AsApi } from './logic/asApi.ts';
export type { UserData } from './logic/asApi.ts';
export { AsText } from './components/text-and-lang/as-text.ts';
// export { serverCodes } from './data/constants.ts';
// Note: localisedText exports are removed as they are still work in progress 